@if (isCurrentUserAssignee()) {
  <div class="row justify-content-center">
    <div class="col-md-auto col-sm-12">
      <div class="alert alert-info">
        <div>
          {{ 'Sie haben eine offene Aufgabe für diese Bedarfsmeldung' | translate }}
        </div>
        <div class="col">
          <div class="row justify-content-center mt-2">
            <div class="col-auto">
              <button class="btn btn-primary btn-sm" (click)="navigate()">
                {{ 'zur Aufgabe' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
